"use client"

import { useEffect, useState, useRef } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import ContentHeader from "../../components/ContentHeader"
import Loader from "../../components/Loader"
import Swal from "sweetalert2"
import axios from "axios"
import "datatables.net-bs4"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
import "select2"
import "select2/dist/css/select2.min.css"
import { Tooltip } from "bootstrap"
import "react-datepicker/dist/react-datepicker.css"
import es from "date-fns/locale/es"
import { safeCurrencyFormat } from "../../utils/currencyFormatter"
import $ from "jquery"

registerLocale("es", es)

const totalSectionStyle = {
  background: "#033c73",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}

const CashCutBranch = () => {
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [dataTicket, setDataTicket] = useState([])
  const [dataPackage, setDataPackage] = useState([])
  const [packagesToCollect, setPackagesToCollect] = useState([])
  const [packagesAdvances, setPackagesAdvances] = useState([])
  const [extraLuggage, setExtraLuggage] = useState([])
  const [dataBills, setDataBills] = useState([])
  const [dataBillsWay, setDataBillsWay] = useState([])
  const [totalSales, setTotalSales] = useState(0)
  const [branches, setBranches] = useState([])
  const [totalFilteredPayments, setTotalFilteredPayments] = useState(0)
  const [selectedBranch, setSelectedBranch] = useState("")
  const [schedules, setSchedules] = useState([])
  const [selectedBranchData, setSelectedBranchData] = useState(null)
  const [dataLoaded, setDataLoaded] = useState(false)
  const selectRef = useRef(null)
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT

  // Funciones auxiliares de formato
  const formatDate = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  const formatTime = (timeString) => {
    if (!timeString) return ""
    const [hours, minutes] = timeString.split(":")
    const date = new Date()
    date.setHours(Number.parseInt(hours))
    date.setMinutes(Number.parseInt(minutes))
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0")
    const ampm = date.getHours() >= 12 ? "PM" : "AM"
    const hours12 = date.getHours() % 12 || 12
    const formattedHours12 = hours12.toString().padStart(2, "0")
    return `${formattedHours12}:${formattedMinutes} ${ampm}`
  }

  const formatCurrency = (value) => {
    return safeCurrencyFormat(value)
  }

  const getDateRangeText = () => {
    if (startDate.toDateString() === endDate.toDateString()) {
      return startDate.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric" })
    } else {
      return `${startDate.toLocaleDateString("es-ES", { day: "numeric", month: "long" })} al ${endDate.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })}`
    }
  }

  // Filtrar boletos con pago con tarjeta o transferencia
  const filteredTickets = dataTicket
    ? dataTicket.filter((item) => item.card_payment == 1 || item.card_payment_transfer == 1)
    : []

  // Filtrar paquetes con pago con tarjeta o transferencia
  const filteredPackages = dataPackage
    ? dataPackage.filter((item) => item.card_payment == 1 || item.cardPaymentTransfer == 1)
    : []

  // Filtrar gastos con pago con tarjeta o transferencia
  const filteredBills = dataBills
    ? dataBills.filter((item) => item.card_payment == 1 || item.card_payment_transfer == 1)
    : []

  // Combinar ambos arrays para la sección de pagos con tarjeta y transferencia
  const allCardPayments = [
    ...filteredTickets.map((ticket) => ({
      date: ticket.date_sale,
      concept: ticket.invoice,
      passenger_name: ticket.name + " " + (ticket.last_name || ""),
      price: parseFloat(ticket.price_ticket || '0'),
      card_payment: ticket.card_payment,
      card_payment_transfer: ticket.card_payment_transfer,
      card_payment_transfer_reference: ticket.transfernumber,
    })),
    ...filteredPackages.map(pkg => ({      
      date: pkg.date_sale || pkg.date_created,
      concept: pkg.invoice_number,
      passenger_name: pkg.description_package,
      price: parseFloat(pkg.price || '0'),      
      card_payment: pkg.card_payment,
      cardPaymentTransfer: pkg.cardPaymentTransfer
    })),
    ...filteredBills.map((bill) => ({
      date: bill.date,
      concept: bill.invoice,
      price: parseFloat(bill.price || '0'),
      card_payment: bill.card_payment,
      card_payment_transfer: bill.card_payment_transfer,
    })),
  ]

  const filteredCardPayments = allCardPayments.filter(
    (item) => item.card_payment === 1 || item.card_payment_transfer === 1 || item.cardPaymentTransfer === 1
  )
  
  // Determinar el tipo de pago
  const getPaymentType = (item) => {
    if (item.card_payment == 1) return "Tarjeta";
    if (item.card_payment_transfer == 1) return "Transferencia";
    if (item.cardPaymentTransfer == 1) return "Transferencia";
    return "Otro";
  };

  // Cargar branches al montar el componente
  useEffect(() => {
    loadBranches()

    // Inicializar tooltips
    setTimeout(() => {
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
    }, 100)
  }, [])

  // Inicializar select2 después de cargar branches
  useEffect(() => {
    if (branches.length > 0 && selectRef.current) {
      $(selectRef.current)
        .select2({
          placeholder: "Seleccionar taquilla...",
          allowClear: true,
          width: "100%",
        })
        .on("change", function () {
          const selectedId = $(this).val()
          setSelectedBranch(selectedId)

          // Guardar los datos de la branch seleccionada
          const branchData = branches.find((branch) => branch.branch_id.toString() === selectedId.toString())
          setSelectedBranchData(branchData || null)
        })
    }
  }, [branches])

  // Función para cargar branches
  const loadBranches = async () => {
    setLoading(true)
    try {
      const response = await axios.get(ENDPOINT + "get-all-branchs-ticket")

      if (response.data && response.data.data) {
        setBranches(response.data.data || [])
      } else {
        console.error("Error al cargar taquillas:", response.data.msg)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">Error al cargar la lista de taquillas</div>',
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      }
    } catch (error) {
      console.error("Error en la solicitud de taquillas:", error)
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Error al conectar con el servidor</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    } finally {
      setLoading(false)
    }
  }

  // Modificar la función formatDateForAPI para incluir la hora
  const formatDateForAPI = (date, isEndDate = false) => {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")

    // Si es fecha final, establecer la hora al final del día
    if (isEndDate) {
      return `${year}-${month}-${day} 23:59:59`
    }

    // Si es fecha inicial, establecer la hora al inicio del día
    return `${year}-${month}-${day} 00:00:00`
  }

  // Validar que se haya seleccionado una branch
  const validateForm = () => {
    if (!selectedBranch) {
      Swal.fire({
        icon: "warning",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Por favor seleccione una taquilla</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
      return false
    }
    return true
  }

  useEffect(() => {
    axios.get(ENDPOINT + "get-all-schedules/2")
        .then(res => setSchedules(res.data.data || []));
  }, []);

  // Función principal para buscar datos
  const handleSearch = async () => {
    if (!validateForm()) return

    const form = new FormData()
    const start_date_format = formatDateForAPI(startDate)
    const end_date_format = formatDateForAPI(endDate, true)

    form.append("start_date", start_date_format)
    form.append("end_date", end_date_format)
    form.append("branch_id", selectedBranch)

    setLoading(true)
    await axios
      .post(ENDPOINT + "cash-cut-branch", form) // Nuevo endpoint para branch
      .then((response) => {
        setLoading(false)
        if (response.data.data) {
          setDataTicket(response.data.data.tickets || [])
          setDataPackage(response.data.data.packages || [])
          setPackagesToCollect(response.data.data.packagesToCollect || [])
          setPackagesAdvances(response.data.data.packagesAdvances || [])
          setExtraLuggage(response.data.data.extraLuggage || [])
          setDataBills(response.data.data.bills || [])
          setDataBillsWay(response.data.data.BillsWay || [])

          // Calcular totales
          const totalTickets = (response.data.data.tickets || []).reduce(
            (a, b) => a + Number.parseFloat(b.price_ticket || 0),
            0,
          )
          const totalPackages = (response.data.data.packages || []).reduce(
            (a, b) => a + Number.parseFloat(b.price || 0),
            0,
          )
          const totalPackagesToCollect = (response.data.data.packagesToCollect || []).reduce(
            (a, b) => a + Number.parseFloat((b.price || 0) - (b.advance || 0)),
            0,
          )
          const totalPackagesAdvances = (response.data.data.packagesAdvances || []).reduce(
            (a, b) => a + Number.parseFloat(b.advance || 0),
            0,
          )
          const totalExtraLuggage = (response.data.data.extraLuggage || []).reduce(
            (a, b) => a + Number.parseFloat(b.price || 0),
            0,
          )
          const totalBills = (response.data.data.bills || []).reduce(
            (a, b) => a + Number.parseFloat(b.price || 0),
            0,
          )
          
          const cardPayments = [
            ...response.data.data.tickets.filter(t => t.card_payment === 1 || t.card_payment_transfer === 1).map(ticket => ({
              price: parseFloat(ticket.price_ticket || '0')
            })),
            ...response.data.data.packages.filter(p => p.card_payment === 1 || p.cardPaymentTransfer === 1).map(pkg => ({
              price: parseFloat(pkg.price || '0')
            })),
            ...response.data.data.bills.filter(b => b.card_payment === 1 || b.card_payment_transfer === 1).map(bill => ({
              price: parseFloat(bill.price || '0')
            }))
          ]

          const totalFilteredPayments = cardPayments.reduce((acc, item) => acc + (isNaN(item.price) ? 0 : item.price), 0)

          setTotalFilteredPayments(totalFilteredPayments)

          const totalBillsWay = (response.data.data.BillsWay || []).reduce(
            (a, b) => a + Number.parseFloat(b.ingreso || 0),
            0,
          )

          setTotalSales(
            totalTickets + totalPackages + totalPackagesToCollect + totalPackagesAdvances + totalExtraLuggage + totalBillsWay - totalBills - totalFilteredPayments
          )

          // Indicar que los datos se han cargado
          setDataLoaded(true)
        } else {
          // Limpiar datos si no hay resultados
          setDataTicket([])
          setDataPackage([])
          setPackagesToCollect([])
          setPackagesAdvances([])
          setExtraLuggage([])
          setDataBills([])
          setDataBillsWay([])
          setTotalSales(0)
          setDataLoaded(false)

          Swal.fire({
            icon: "info",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: true,
            html: '<div class="text-custom-alert">No se encontraron datos para el rango de fechas y taquilla seleccionados</div>',
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
          })
        }
      })
      .catch((error) => {
        setLoading(false)
        setDataLoaded(false)
        console.error("Error en la solicitud:", error)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html:
            '<div class="text-custom-alert">' +
            (error.response?.data?.msg || "Error al procesar la solicitud") +
            "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }

  const resetPage = () => {
    window.location.reload()
  }

  // Función para exportar a Excel
  const handlePrint = async () => {
    if (!validateForm()) return

    setLoading(true)
    const form = new FormData()
    const start_date_format = formatDateForAPI(startDate)
    const end_date_format = formatDateForAPI(endDate, true)

    form.append("start_date", start_date_format)
    form.append("end_date", end_date_format)
    form.append("branch_id", selectedBranch)

    try {
      const response = await axios.post(ENDPOINT + "export-cash-cut-branch", form, { responseType: "blob" })

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
      )
      const link = document.createElement("a")
      link.href = url
      const startDateStr = formatDateForAPI(startDate).split(" ")[0]
      const endDateStr = formatDateForAPI(endDate).split(" ")[0]

      // Obtener el nombre de la branch seleccionada
      const branchName = selectedBranchData?.name || selectedBranch

      link.setAttribute("download", `corte-de-caja-${branchName}-${startDateStr}-a-${endDateStr}.xlsx`)
      document.body.appendChild(link)
      link.click()
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error("Error al exportar:", error)
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Error! No hay datos para descargar</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    }
  }

  // Función para generar PDF
  const generatePDF = () => {
    if (!selectedBranchData) return

    // Crear un elemento temporal para imprimir
    const printContent = document.createElement("div")
    printContent.className = "print-content"

    // Estilos para impresión
    const style = document.createElement("style")
    style.textContent = `
      @media print {
        body * {
          visibility: hidden;
        }
        .print-content, .print-content * {
          visibility: visible;
        }
        .print-content {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        .print-header {
          background-color: #033c73 !important;
          color: white !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .print-section-header {
          background-color: #033c73 !important;
          color: white !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .print-summary {
          background-color: #f5f5f5 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f5f5f5 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .text-right {
          text-align: right;
        }
        .text-center {
          text-align: center;
        }
        .page-break {
          page-break-after: always;
        }
        .footer {
          position: fixed;
          bottom: 0;
          width: 100%;
          text-align: center;
          font-size: 10px;
          color: #999;
        }
      }
    `
    document.head.appendChild(style)

    // Fecha y hora de generación
    const now = new Date()
    const generationDate = `${formatDate(now.toISOString())} ${formatTime(now.getHours() + ":" + now.getMinutes())}`

    // Crear el contenido del PDF
    printContent.innerHTML = `
      <div class="container">
        <!-- Encabezado -->
        <div class="row print-header p-3 mb-4">
          <div class="col-12 text-center">
            <h1>CORTE DE CAJA POR TAQUILLA</h1>
            <h3>TRANSPORTES SALINACRUCENSES</h3>
          </div>
        </div>

        <!-- Información del reporte -->
        <div class="row mb-4">
          <div class="col-6">
            <h4>INFORMACIÓN DEL REPORTE</h4>
            <hr>
            <p>Taquilla: ${selectedBranchData.name}</p>
            <p>Periodo: ${formatDate(startDate.toISOString())} al ${formatDate(endDate.toISOString())}</p>
            <p>Generado: ${generationDate}</p>
          </div>
          <div class="col-6">
            <div class="print-summary p-3">
              <h4 class="text-center">RESUMEN FINANCIERO</h4>
              <div class="row">
                <div class="col-6">Total Ventas:</div>
                <div class="col-6 text-right">$${formatCurrency(totalSales)}</div>
              </div>
              <div class="row">
                <div class="col-6">Total Gastos:</div>
                <div class="col-6 text-right">$${formatCurrency(dataBills.reduce((a, b) => a + Number.parseFloat(b.price), 0))}</div>
              </div>
              <div class="row">
                <div class="col-6">Balance Final:</div>
                <div class="col-6 text-right">$${formatCurrency(totalSales - dataBills.reduce((a, b) => a + Number.parseFloat(b.price), 0))}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sección de Boletos -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="print-section-header p-2 text-center text-white">
              <h5>BOLETOS</h5>
            </div>
            <table class="table table-bordered mt-2">
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Fecha Venta</th>
                  <th>Fecha Viaje</th>
                  <th>Horario</th>
                  <th>Destino</th>
                  <th>Precio</th>
                </tr>
              </thead>
              <tbody>
                ${dataTicket.length > 0
        ? dataTicket
          .map(
            (item) => `
                    <tr>
                      <td>${item.invoice}</td>
                      <td>${formatDate(item.date_sale)}</td>
                      <td>${formatDate(item.date_ticket)}</td>
                      <td>${formatTime(item.time_ticket)}</td>
                      <td>${item.destination?.name || "N/A"}</td>
                      <td class="text-right">$${formatCurrency(item.price_ticket)}</td>
                    </tr>
                  `,
          )
          .join("")
        : '<tr><td colspan="6" class="text-center">No hay datos para mostrar</td></tr>'
      }
                <tr>
                  <td colspan="5" class="text-right"><strong>Total:</strong></td>
                  <td class="text-right"><strong>$${formatCurrency(dataTicket.reduce((a, b) => a + Number.parseFloat(b.price_ticket), 0))}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Sección de Paquetería -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="print-section-header p-2 text-center text-white">
              <h5>PAQUETERÍA</h5>
            </div>
            <table class="table table-bordered mt-2">
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Fecha Venta</th>
                  <th>Fecha Envío</th>
                  <th>Horario</th>
                  <th>Destino</th>
                  <th>Precio</th>
                </tr>
              </thead>
              <tbody>
                ${dataPackage.length > 0
        ? dataPackage
          .map(
            (item) => `
                    <tr>
                      <td>${item.invoice_number}</td>
                      <td>${formatDate(item.date_created)}</td>
                      <td>${formatDate(item.date_send)}</td>
                      <td>${formatTime(item.time_send)}</td>
                      <td>${item.destination?.name || "N/A"}</td>
                      <td class="text-right">$${formatCurrency(item.price)}</td>
                    </tr>
                  `,
          )
          .join("")
        : '<tr><td colspan="6" class="text-center">No hay datos para mostrar</td></tr>'
      }
                <tr>
                  <td colspan="5" class="text-right"><strong>Total:</strong></td>
                  <td class="text-right"><strong>$${formatCurrency(dataPackage.reduce((a, b) => a + Number.parseFloat(b.price), 0))}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Resto de las secciones (Paquetería por Cobrar, Anticipos, Equipaje Extra, etc.) -->
        <!-- ... (similar al contenido de CashCutUser pero adaptado para branch) ... -->

        <!-- Pie de página -->
        <div class="footer">
          Página 1 | TRANSPORTES SALINACRUCENSES | Reporte generado el ${generationDate}
        </div>
      </div>
    `

    // Añadir el contenido al documento
    document.body.appendChild(printContent)

    // Configurar opciones de impresión
    const fileName = `corte-caja-${selectedBranchData.name.toLowerCase()}-${formatDate(startDate.toISOString()).replace(/\//g, "-")}.pdf`

    // Abrir diálogo de impresión
    window.print()

    // Limpiar después de imprimir
    setTimeout(() => {
      document.body.removeChild(printContent)
      document.head.removeChild(style)
    }, 1000)
  }

  const getSelectedBranchName = () => {
    const branch = branches.find((br) => br.branch_id.toString() === selectedBranch.toString())
    if (!branch) return "No seleccionada"
    return branch.name
  }

  const renderScheduleTime = (item) => {
    if (item.time) return formatTime(item.time);
    
    if (item.schedule_id) {
        const schedule = schedules.find(s => s.schedule_id == item.schedule_id);
        if (schedule) return formatTime(schedule.time);
    }
    
    return '--:--';
  };

  return (
    <div>
      {loading && <Loader />}
      <div className="container-fluid">
        <ContentHeader title="Módulo de Reportes" />
      </div>

      <div className="container-fluid">
        <div className="card shadow-sm">
          <div className="card-header py-3">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h4 className="card-title m-0 page-title d-flex align-items-center">
                  <i className="bi bi-cash me-2"></i> Corte de Caja por Taquilla
                </h4>
              </div>
              <div className="col-md-4 text-md-end">
                <button onClick={resetPage} className="btn btn-info btn-sm" type="button">
                  <i className="fa fa-refresh me-1"></i> Recargar
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row g-4 mb-4">
              <div className="col-lg-7">
                <div className="search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                  <div className="add-trips-card-body">
                    <div className="mb-4">
                      <h6 className="text-muted mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        Seleccione una taquilla y un rango de fechas para visualizar el corte de caja
                      </h6>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <label htmlFor="branch" className="form-label fw-bold mb-2">
                          <i className="fas fa-building me-2"></i>
                          Taquilla
                        </label>
                        <select
                          ref={selectRef}
                          className="form-select form-select-sm"
                          id="branch"
                          onChange={(e) => setSelectedBranch(e.target.value)}
                        >
                          <option value="">Seleccionar taquilla...</option>
                          {branches.map((branch) => (
                            <option key={branch.branch_id} value={branch.branch_id}>
                              {branch.name}
                            </option>
                          ))}
                        </select>
                        <small className="text-muted mt-1 d-block">
                          Seleccione la taquilla para generar su corte de caja
                        </small>
                      </div>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-7 mb-3 mb-md-0">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="startDate" className="form-label fw-bold mb-2">
                              <i className="far fa-calendar-alt me-2"></i>
                              Fecha Inicial
                            </label>
                            <div className="input-group">
                              <DatePicker
                                showIcon
                                locale="es"
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd, MMMM, yyyy"
                                placeholderText="Fecha inicial..."
                                maxDate={endDate}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="endDate" className="form-label fw-bold mb-2">
                              <i className="far fa-calendar-alt me-2"></i>
                              Fecha Final
                            </label>
                            <div className="input-group">
                              <DatePicker
                                showIcon
                                locale="es"
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd, MMMM, yyyy"
                                placeholderText="Fecha final..."
                                minDate={startDate}
                              />
                            </div>
                          </div>
                        </div>
                        <small className="text-muted mt-1 d-block">
                          La información corresponderá al rango de fechas seleccionado
                        </small>
                      </div>
                      <div className="col-md-5">
                        <div className="d-grid gap-2">
                          <button
                            onClick={() => handleSearch()}
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2"
                          >
                            <i className="fa fa-search me-2"></i> Buscar
                          </button>
                          <div className="d-flex gap-2">
                            <button
                              onClick={() => handlePrint()}
                              className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2 flex-grow-1"
                            >
                              <i className="fa-solid fa-file-excel me-2"></i> Excel
                            </button>

                            {dataLoaded && selectedBranchData && (
                              <button
                                onClick={generatePDF}
                                className="btn btn-sm d-flex align-items-center justify-content-center py-2"
                                style={{ backgroundColor: "#033c73", color: "white" }}
                              >
                                <i className="fa-solid fa-file-pdf me-2"></i> Exportar a PDF
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  className="cash-cut-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden"
                  style={totalSectionStyle}
                >
                  <div className="position-relative z-1">
                    <h6 className="text-white-50 mb-3">Total de ventas del período</h6>
                    <h2 className="display-4 fw-bold mb-0">
                      {formatCurrency(totalSales)}
                    </h2>
                    <p className="mb-0 mt-2 text-white-50">
                      <i className="fas fa-building me-1"></i> {getSelectedBranchName()}
                    </p>
                    <p className="mb-0 mt-1 text-white-50">
                      <i className="fas fa-calendar-day me-1"></i> {getDateRangeText()}
                    </p>
                  </div>
                  <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                    <i className="fas fa-chart-line" style={{ fontSize: "5rem" }}></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Aquí van todas las secciones de tablas (Boletos, Paquetería, etc.) */}
            {/* Similar a CashCutUser pero adaptado para branch */}
            {/* Boletos */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-ticket-alt me-2"></i>
                  Boletos del Período
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro detallado de todos los boletos vendidos durante el período seleccionado.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Boletos</small>
                <h4 className="m-0">
                  {formatCurrency(dataTicket.reduce((a, b) => a + Number.parseFloat(b.price_ticket), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-ticket-alt me-2"></i> Boletos
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="18%" className="text-center">Folio</th>
                      
                      <th width="18%" className="text-center">Fecha Viaje</th>
                      <th width="18%" className="text-center">Horario</th>
                      <th width="22%" className="text-center">Destino</th>
                      <th width="23%" className="text-center">Precio</th>
                    </tr>
                  </thead>
                  {dataTicket.length > 0 ? (
                    <tbody>
                      {dataTicket.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice}</td>
                          
                          <td className="text-center">{formatDate(item.date_ticket)}</td>
                          <td className="text-center">{formatTime(item.time_ticket)}</td>
                          <td className="text-center">{item.destination?.name || "N/A"}</td>
                          <td className="text-center">{formatCurrency(item.price_ticket)}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="5" className="text-end"><strong>Total</strong></td>
                        <td className="text-center">
                          <strong>{formatCurrency(dataTicket.reduce((a, b) => a + Number.parseFloat(b.price_ticket), 0))}</strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center">No hay datos para mostrar</td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

             <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-box me-2"></i>
                  Paquetería
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Resumen de envíos y paquetes procesados en el período seleccionado.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Paquetería</small>
                <h4 className="m-0">
                  $
                  {dataPackage
                    .reduce((a, b) => a + Number.parseFloat(b.price), 0)
                    .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-box me-2"></i> Paqueteria
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="25%" className="text-center">
                        Folio
                      </th>
                      <th width="25%" className="text-center">
                        Fecha de Envio
                      </th>
                      <th width="25%" className="text-center">
                        Horario
                      </th>
                      <th width="25%" className="text-center">
                        Precio
                      </th>
                    </tr>
                  </thead>
                  {dataPackage.length > 0 ? (
                    <tbody>
                      {dataPackage.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice_number}</td>
                          <td className="text-center">{formatDate(item.date_send)}</td>
                          <td className="text-center">{formatTime(item.time_send)}</td>
                          <td className="text-center">
                            $
                            {item.price.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {dataPackage
                              .reduce((a, b) => a + Number.parseFloat(b.price), 0)
                              .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="4" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-list me-2"></i>
                  Paquetería por Cobrar
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Detalle de paquetes pendientes de cobro al destinatario.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total por Cobrar</small>
                <h4 className="m-0">
                  $
                  {packagesToCollect
                    .reduce((a, b) => a + Number.parseFloat(b.price - b.advance), 0)
                    .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-money-bill me-2"></i> Paqueteria Por Cobrar
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="25%" className="text-center">
                        Folio
                      </th>
                      <th width="25%" className="text-center">
                        Fecha de Envio
                      </th>
                      <th width="25%" className="text-center">
                        Horario
                      </th>
                      <th width="25%" className="text-center">
                        Precio
                      </th>
                    </tr>
                  </thead>
                  {packagesToCollect.length > 0 ? (
                    <tbody>
                      {packagesToCollect.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice_number}</td>
                          <td className="text-center">{formatDate(item.date_send)}</td>
                          <td className="text-center">{formatTime(item.time_send)}</td>
                          <td className="text-center">
                            $
                            {(item.price - item.advance).toLocaleString("es-MX", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {packagesToCollect
                              .reduce((a, b) => a + Number.parseFloat(b.price - b.advance), 0)
                              .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="4" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-money-bill-wave me-2"></i>
                  Anticipos de Paquetería
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Lista de pagos anticipados recibidos por servicios de paquetería.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Anticipos</small>
                <h4 className="m-0">
                  $
                  {packagesAdvances
                    .reduce((a, b) => a + Number.parseFloat(b.advance), 0)
                    .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-hand-holding-usd me-2"></i> Anticipos Paqueterias
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Destinatario
                      </th>
                      <th width="20%" className="text-center">
                        Destino
                      </th>
                      <th width="20%" className="text-center">
                        Monto
                      </th>
                      <th width="20%" className="text-center">
                        Folio
                      </th>
                    </tr>
                  </thead>
                  {packagesAdvances.length > 0 ? (
                    <tbody>
                      {packagesAdvances.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time_send)}</td>
                          <td className="text-center">{item.addressee}</td>
                          <td className="text-center">{item.destination.name}</td>
                          <td className="text-center">
                            $
                            {item.advance.toLocaleString("es-MX", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className="text-center">{item.invoice_number}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {packagesAdvances
                              .reduce((a, b) => a + Number.parseFloat(b.advance), 0)
                              .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-suitcase me-2"></i>
                  Equipaje Extra
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de cargos adicionales por equipaje extra de pasajeros.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Equipaje Extra</small>
                <h4 className="m-0">
                  $
                  {extraLuggage
                    .reduce((a, b) => a + Number.parseFloat(b.price), 0)
                    .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-suitcase me-2"></i> Equipaje extra
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Folio
                      </th>
                      <th width="20%" className="text-center">
                        Fecha
                      </th>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Concepto
                      </th>
                      <th width="20%" className="text-center">
                        Precio
                      </th>
                    </tr>
                  </thead>
                  {extraLuggage.length > 0 ? (
                    <tbody>
                      {extraLuggage.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice}</td>
                          <td className="text-center">{formatDate(item.date)}</td>
                          <td className="text-center">{formatTime(item.time)}</td>
                          <td className="text-center">{item.concept}</td>
                          <td className="text-center">
                            $
                            {item.price.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {extraLuggage
                              .reduce((a, b) => a + Number.parseFloat(b.price), 0)
                              .toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            {/* Sección de Ingresos de Camino */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-bus me-2"></i>
                  Ingresos de Camino
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de ingresos de camino durante el período seleccionado.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Ingresos de Camino</small>
                <h4 className="m-0">
                  {formatCurrency(dataBillsWay.reduce((a, b) => a + Number.parseFloat(b.monto_ingreso || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-bus me-2"></i> Ingresos de Camino
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">Fecha</th>
                      <th width="20%" className="text-center">Sucursal</th>
                      <th width="20%" className="text-center">Horario</th>
                      <th width="20%" className="text-center">Concepto</th>
                      <th width="20%" className="text-center">Monto</th>
                    </tr>
                  </thead>
                  {dataBillsWay.length > 0 ? (
                    <tbody>
                      {dataBillsWay.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatDate(item.fecha_viaje)}</td>
                          <td className="text-center">{item.branch?.name || 'N/A'}</td>
                          <td className="text-center">{renderScheduleTime(item)}</td>
                          <td className="text-center">{item.notas || 'Sin notas'}</td>
                          <td className="text-center">{formatCurrency(item.monto_ingreso)}</td>
                        </tr>

                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            {formatCurrency(dataBillsWay.reduce((a, b) => a + Number.parseFloat(b.monto_ingreso || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            {/* Sección de pagos con tarjeta y transferencia */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-file-invoice-dollar me-2"></i>
                  Pagos con tarjeta y transferencia
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Pagos hechos con tarjeta o transferencia.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total pagos</small>
                <h4 className="m-0">
                  -$
                  {totalFilteredPayments.toLocaleString("es-MX", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-file-invoice-dollar me-2"></i> Pagos con tarjeta y transferencia
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="15%" className="text-center">
                        Fecha
                      </th>
                      <th width="15%" className="text-left">
                        Folio
                      </th>
                      <th width="25%" className="text-center">
                        Nombre Pasajero
                      </th>
                      <th width="10%" className="text-center">
                        Tipo Pago
                      </th>
                      <th width="10%" className="text-center">
                        Anotacion
                      </th>
                      <th width="15%" className="text-center">
                        Cantidad
                      </th>
                    </tr>
                  </thead>
                  {allCardPayments.length > 0 ? (
                    <tbody>
                      {filteredCardPayments.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatDate(item.date)}</td>
                          <td className="text-left">{item.concept}</td>
                          <td className="text-center">{item.passenger_name || "-"}</td>
                          <td className="text-center">{getPaymentType(item)}</td>
                          <td className="text-left">{item.card_payment_transfer_reference}</td>
                          <td className="text-center">
                            -$
                            {item.price.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total Gastos</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            -$
                            {totalFilteredPayments.toLocaleString("es-MX", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-file-invoice-dollar me-2"></i>
                  Gastos por Unidad
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de gastos operativos asociados a cada unidad de transporte.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Gastos</small>
                <h4 className="m-0">
                  -$
                  {formatCurrency(dataBills.reduce((a, b) => a + Number.parseFloat(b.price), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-file-invoice-dollar me-2"></i> Gastos por unidad
                </h4>
              </div>
              <table className="table table-hover main table-striped table-responsive">
                <thead>
                  <tr>
                    <th width="15%" className="text-center">
                      Fecha
                    </th>
                    <th width="20%" className="text-left">Concepto</th>
                                        <th width="25%" className="text-left">Unidad</th>
                                        <th width="25%" className="text-left">Condcutor</th>
                    <th width="15%" className="text-center">
                      Monto
                    </th>
                  </tr>
                </thead>
                {dataBills.length > 0 ? (
                  <tbody>
                    {dataBills.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{formatDate(item.date)}</td>
                        <td className="text-left">{item.concept}</td>
                        <td className="text-left">
                                                    {item.unit.name}
                                                </td>
                                                <td className="text-left">
                                                    {item.driver.name}
                                                </td>
                        <td className="text-center">
                          -{formatCurrency(item.price)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="4" className="text-end">
                        <strong>Total Gastos</strong>
                      </td>
                      <td className="text-center">
                        <strong>
                          -{formatCurrency(dataBills.reduce((a, b) => a + Number.parseFloat(b.price), 0))}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="4" className="text-end">
                        <strong>Total (Total Gastos - Total Transferencias y Tarjetas)</strong>
                      </td>
                      <td className="text-center">
                        <strong>
                          {formatCurrency(
                           
                            dataBills.reduce((a, b) => a + Number.parseFloat(b.price), 0) +
                            totalFilteredPayments
                          )}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="3" className="text-center">
                        No hay datos para mostrar
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          

          </div>
        </div>
      </div>
    </div>
  )
}

export default CashCutBranch
